.paginationRoot {
  display: var(--haus-pagination__paginationRoot__display, grid);
  gap: var(--haus-pagination__paginationRoot__gap, 16px);
  justify-items: var(--haus-pagination__paginationRoot__justify-items, center);
  margin: var(--haus-pagination__paginationRoot__margin, 32px 0);

  @include bp.tablet-min {
    gap: var(--haus-pagination__paginationRoot__gap-md, 24px);
    margin: var(--haus-pagination__paginationRoot__margin-md, 64px 0);
  }
}

.counter {
  margin: var(--haus-pagination__counter__margin, 0);
}

.nextPageButton {
  display: var(--haus-pagination__nextPageButton__display, var(--haus-button-display, inline-flex));
  align-items: var(
    --haus-pagination__nextPageButton__align-items,
    var(--haus-button-align-items, center)
  );
  justify-content: var(
    --haus-pagination__nextPageButton__justify-content,
    var(--haus-button-justify-content, center)
  );
  min-height: var(--haus-pagination__nextPageButton__min-height, 44px);
  min-width: var(--haus-pagination__nextPageButton__min-width, 44px);
  padding: var(--haus-pagination__nextPageButton__padding, var(--haus-button-padding, 0 10px));
  background-color: var(
    --haus-button-background-color,
    var(--haus-pagination__nextPageButton__background, var(--haus-color-primary, #000))
  );
  color: var(--haus-button-text-color, var(--haus-pagination__nextPageButton__color, #fff));
  border-color: var(
    --haus-button-border-color,
    var(--haus-pagination__nextPageButton__border-color, transparent)
  );
  border-style: var(
    --haus-button-border-style,
    var(--haus-pagination__nextPageButton__border-style, solid)
  );
  border-width: var(
    --haus-button-border-width,
    var(--haus-pagination__nextPageButton__border-width, 0)
  );
  border-radius: var(
    --haus-button-border-radius,
    var(--haus-pagination__nextPageButton__border-radius, 6px)
  );
  font-size: var(--haus-button-font-size, 1rem);
  font-weight: var(--haus-button-font-weight, 400);
  text-decoration: var(
    --haus-button-text-decoration,
    var(--haus-pagination__nextPageButton__text-decoration, none)
  );
  cursor: var(--haus-pagination__nextPageButton__cursor, var(--haus-button-cursor, pointer));
  transition: var(--haus-button-transition, 0.2s ease);

  &:hover:not(:disabled) {
    background-color: var(
      --haus-button-hover-background-color,
      var(
        --haus-pagination__nextPageButton--hover__background,
        var(--haus-color-secondary, #003a70)
      )
    );
    color: var(
      --haus-button-hover-text-color,
      var(--haus-pagination__nextPageButton--hover__color, #fff)
    );
    border-color: var(--haus-button-hover-border-color, transparent);
    border-style: var(--haus-button-hover-border-style, solid);
  }

  &:focus-visible {
    outline: var(--haus-pagination__nextPageButton--focus-visible__outline, 2px solid currentColor);
    outline-offset: var(--haus-pagination__nextPageButton--focus-visible__outline-offset, 2px);
  }
}

.numberedPagination {
  display: var(--haus-pagination__numberedPagination__display, flex);
  align-items: var(--haus-pagination__numberedPagination__align-items, center);
  gap: var(--haus-pagination__numberedPagination__gap, 8px);
  flex-wrap: var(--haus-pagination__numberedPagination__flex-wrap, wrap);
  justify-content: var(--haus-pagination__numberedPagination__justify-content, center);
}

.numberedPaginationSkeletonPlaceholder {
  max-width: var(--haus-pagination__numberedPaginationSkeletonPlaceholder__max-width, 320px);
  border-radius: var(--haus-pagination__nextPageButton__border-radius, 6px);
}

.pageNumbers {
  display: var(--haus-pagination__pageNumbers__display, flex);
  align-items: var(--haus-pagination__pageNumbers__align-items, center);
}

.pageLink {
  display: var(--haus-pagination__pageLink__display, inline-flex);
  align-items: var(--haus-pagination__pageLink__align-items, center);
  justify-content: var(--haus-pagination__pageLink__justify-content, center);
  min-width: var(--haus-pagination__pageLink__min-width, 44px);
  min-height: var(--haus-pagination__pageLink__min-height, 44px);
  color: var(--haus-pagination__pageLink__color, #333);
  text-decoration: var(--haus-pagination__pageLink__text-decoration, none);
  border: var(--haus-pagination__pageLink__border, none);
  border-radius: var(--haus-pagination__pageLink__border-radius, 0);
  background: var(--haus-pagination__pageLink__background, transparent);
  cursor: var(--haus-pagination__pageLink__cursor, pointer);
  transition: var(--haus-pagination__pageLink__transition, color 0.2s);

  svg {
    stroke: var(--haus-pagination__pageLinkIcon__stroke, #333);
    stroke-width: var(--haus-pagination__pageLinkIcon__stroke-width, 0.5);
  }

  &:hover {
    color: var(--haus-pagination__pageLink--hover__color, var(--haus-color-primary, #000));

    svg {
      stroke: var(--haus-pagination__pageLinkIcon--hover__stroke, var(--haus-color-primary, #000));
    }
  }

  &:focus-visible {
    outline: var(--haus-pagination__pageLink--focus-visible__outline, 2px solid currentColor);
    outline-offset: var(--haus-pagination__pageLink--focus-visible__outline-offset, 2px);
  }
}

.pageNumberActive {
  border: var(--haus-pagination__pageNumberActive__border, none);
  background: var(--haus-pagination__pageNumberActive__background, transparent);
  color: var(--haus-pagination__pageNumberActive__color, var(--haus-color-primary, #000));
  font-weight: var(--haus-pagination__pageNumberActive__font-weight, 600);

  &:hover {
    background: var(--haus-pagination__pageNumberActive--hover__background, transparent);
    color: var(
      --haus-pagination__pageNumberActive--hover__color,
      var(--haus-color-secondary, #003a70)
    );
  }

  &:focus-visible {
    outline: var(
      --haus-pagination__pageNumberActive--focus-visible__outline,
      2px solid currentColor
    );
    outline-offset: var(--haus-pagination__pageNumberActive--focus-visible__outline-offset, 2px);
  }
}

.ellipsis {
  padding: var(--haus-pagination__ellipsis__padding, 0 4px);
  color: var(--haus-pagination__ellipsis__color, #666);
  user-select: var(--haus-pagination__ellipsis__user-select, none);
}

.srOnly {
  position: var(--haus-pagination__srOnly__position, absolute);
  width: var(--haus-pagination__srOnly__width, 1px);
  height: var(--haus-pagination__srOnly__height, 1px);
  padding: var(--haus-pagination__srOnly__padding, 0);
  margin: var(--haus-pagination__srOnly__margin, -1px);
  overflow: var(--haus-pagination__srOnly__overflow, hidden);
  clip-path: var(--haus-pagination__srOnly__clip-path, inset(50%));
  white-space: var(--haus-pagination__srOnly__white-space, nowrap);
  border: var(--haus-pagination__srOnly__border, 0);
}
